import * as React from 'react';

import SignUpButtonGroup from './SignUpButtonGroupPage';
import StaticPageLayout from '#/layouts/StaticPageLayout';

const TermsOfServicePage = () => {
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <StaticPageLayout>
      <div>
        <div className="px-32 py-20 bg-blue-50">
          <div className="px-20 py-16 bg-white">
            <div className="flex flex-col text-gray-600 gap-y-10">
              <h2 className="text-black">Introduction</h2>
              <div className="space-y-5 text-justify">
                <p>
                  We, Daily Move Sdn Bhd, a company incorporated in Malaysia with CCM registration
                  number of 1261065–T with its registered office at Unit 120, Standard Chartered
                  Building, 2 Beach Street 10300 Georgetown, Penang. (“Daily Move”) hereinafter
                  referred to as ("MOVE”, "we", “us", "our" or "Company"), would like to thank you
                  hereinafter referred to as (“you”, “user”, “transporter” or “client”) for visiting
                  our website move.com,my, mobile site, or mobile app ("Site" or “Platform”).
                </p>
                <p>
                  Your terms of use of our Site and the provision of services by us through the Site
                  shall be governed by the terms and conditions as set out herein ("User
                  Agreement"), our privacy policy ("Privacy Policy") and all other policies on our
                  site.
                </p>
                <p>
                  Please make sure to carefully read through these Terms before accessing or using
                  the Site. Your use of our Site constitutes your full agreement to our User
                  Agreement, our Privacy Policy and all other policies, which shall form a legally
                  binding and enforceable contract between you and us.
                </p>
                <p>
                  By using or accessing the Site or Platform, you hereby expressly affirm that:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>you have read and understand these Terms;</li>
                    <li>you will comply with these Terms;</li>
                    <li>you will comply with Community Guidelines; and</li>
                  </ol>
                </p>
                <p>
                  You also acknowledge and agree that you have the authority to enter into these
                  Terms personally and, if applicable, on behalf of any organisation on whose behalf
                  you have enrolled for use of the Platform and to bind such organisation to these
                  Terms.
                </p>
                <p>
                  If you do not accept any provision in this User Agreement or our Privacy Policy,
                  you should immediately cease all usage of our Site and notify us to discontinue
                  any updates which you have signed up for, failing which you shall be deemed to be
                  bound by all the provisions contained in this User Agreement, Privacy Policy and
                  all other policies.
                </p>
              </div>
              <h4>1. Application and Acceptance of the Terms</h4>
              <div className="space-y-5 text-justify">
                <p>
                  1.1 Your use of the Sites and MOVE’s services, software and products (collectively
                  the as the “Services” hereinafter) is subject to the terms and conditions
                  contained in this document as well as the Privacy Policy and any other rules and
                  policies of the Sites that move.com.my may publish from time to time. This
                  document and such other rules and policies of the Sites are collectively referred
                  to below as the “Terms”. We encourage you to review these Terms periodically to
                  stay informed about our practices. Whenever we make changes to these Terms, they
                  are effective when the revised Terms are posted unless we notify you otherwise. If
                  you continue to use the Platform after the revised Terms have been posted, then
                  you will be deemed to have accepted the changes to these Terms.
                </p>
                <p>
                  1.2 You may not use the Services and may not accept the Terms if you are not of
                  legal age to form a binding contract with MOVE.
                </p>
                <p>
                  1.3 MOVE may amend any Terms at any time by posting the relevant amended and
                  restated Terms on the Sites. By continuing to use the Services or the Sites, you
                  agree that the amended Terms will apply to you.
                </p>
                <p>
                  1.4 If MOVE has posted or provided a translation of the English language version
                  of the Terms, you agree that the translation is provided for convenience only and
                  that the English language version will govern your uses of the Services or the
                  Sites.
                </p>
                <p>
                  1.5 You may be required to enter into a separate agreement, whether online or
                  offline, with move.com.my or our affiliate for any Service (“Additional
                  Agreements”). If there is any conflict or inconsistency between the Terms and an
                  Additional Agreement, the Additional Agreement shall take precedence over the
                  Terms only in relation to that Service concerned.
                </p>
                <p>
                  1.6 The Terms may not otherwise be modified except in writing by an authorised
                  officer of move.com.my.
                </p>
              </div>
              <h4>2. Provisions of Service</h4>
              <div className="space-y-5 text-justify">
                <p>
                  2.1 The contracting entity that you are contracting with is Daily Move Sdn Bhd if
                  you are a registered member of the Sites and registered or resident in Malaysia.
                </p>
                <p>
                  2.2 You must register as a member on the Sites in order to access and use some
                  Services. Further, MOVE reserves the right, without prior notice, to restrict
                  access to or use of certain Services (or any features within the Services) to
                  paying Users or subject to other conditions that MOVE may impose at our
                  discretion.
                </p>
                <p>
                  2.3 Services (or any features within the Services) may vary for different regions
                  and countries. No warranty or representation is given that a particular Service or
                  feature or function thereof or the same type and extent of the Service or features
                  and functions thereof will be available for Users. MOVE may in our sole discretion
                  limit, deny or create different levels of access to and use of any Services (or
                  any features within the Services) with respect to different Users.
                </p>
                <p>
                  2.4 MOVE may launch, change, upgrade, impose conditions to, suspend, or stop any
                  Services (or any features within the Services) without prior notice except that in
                  case of a fee-based Service, such changes will not substantially adversely affect
                  the paying Users in enjoying that Service.
                </p>
                <p>2.5 Some Services may be provided by MOVE’s affiliates on behalf of MOVE.</p>
                <p>
                  2.6 The services provided by MOVE (“Services”) are meant to connect Users
                  (Clients) and independent third party delivery partners (“Transporter”) who
                  provide transportation, logistics and/or delivery services. The transportation
                  and/or logistics services provided by the Transporter could be availed/requested
                  through the use of the Platform supplied by MOVE. MOVE is not responsible for the
                  acts and/or omissions of any partners. partners shall bear all liability in
                  relation to such goods and services. You acknowledge that MOVE by itself or any of
                  its affiliates does not own, employ or provide transportation and/or logistics
                  services or function as a transportation carrier and that all such transportation,
                  or logistics services are provided by the Transporter.
                </p>
              </div>
              <h4>3. Users Generally</h4>
              <div className="space-y-5 text-justify">
                <p>
                  3.1 As a condition of your access to and use of the Sites or Services, you agree
                  that you will comply with all applicable laws and regulations when using the Sites
                  or Services.
                </p>
                <p>
                  3.2 You agree to use the Sites or Services solely for your own private and
                  internal purposes. You agree that (a) you will not copy, reproduce, download,
                  re-publish, sell, distribute or resell any Services or any information, text,
                  images, graphics, video clips, sound, directories, files, databases or listings,
                  etc available on or through the Sites (the “Site Content”), and (b) you will not
                  copy, reproduce, download, compile or otherwise use any Site Content for the
                  purposes of operating a business that competes with MOVE, or otherwise
                  commercially exploiting the Site Content. Systematic retrieval of Site Content
                  from the Sites to create or compile, directly or indirectly, a collection,
                  compilation, database or directory (whether through robots, spiders, automatic
                  devices or manual processes) without written permission from MOVE is prohibited.
                  Use of any content or materials on the Sites for any purpose not expressly
                  permitted in the Terms is prohibited.
                </p>
                <p>
                  3.3 You must read MOVE’s Privacy Policy which governs the protection and use of
                  personal information about Users in the possession of move.com.my and our
                  affiliates.
                </p>
                <p>
                  3.4 MOVE may allow Users to access to content, products or services offered by
                  third parties through hyperlinks (in the form of word link, banners, channels or
                  otherwise), API or otherwise to such third parties' websites. You are cautioned to
                  read such websites' terms and conditions and/or privacy policies before using the
                  Sites. You acknowledge that MOVE has no control over such third parties' websites,
                  does not monitor such websites, and shall not be responsible or liable to anyone
                  for such websites, or any content, products or services made available on such web
                  sites.
                </p>
                <p>
                  3.5 You agree not to undertake any action to undermine the integrity of the
                  computer systems or networks of MOVE and/or any other User nor to gain
                  unauthorised access to such computer systems or networks.
                </p>
                <p>
                  3.6 You agree not to undertake any action which may undermine the integrity of
                  MOVE’s feedback system, such as leaving positive feedback for yourself using
                  secondary Member IDs or through third parties or by leaving unsubstantiated
                  negative feedback for another User.
                </p>
                <p>
                  3.7 While using the software provided by MOVE (“Platform”) you agree that:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      you are permitted to install a copy of the Platform on your mobile device for
                      your use;
                    </li>
                    <li>
                      you are not permitted to rent, lease, sublicense, distribute or transfer
                      copies of the Platform or the licence for the use of the Platform to any third
                      parties;
                    </li>
                    <li>
                      you shall not probe, scan or test the vulnerability of the Platform or any
                      network connected to the Platform nor breach the security or authentication
                      measures on the Platform or any network connected to the Platform;
                    </li>
                    <li>
                      you shall not modify, adapt, reverse engineer, decompile, disassemble,
                      translate the Platform or create derivative works based on the Platform;
                    </li>
                    <li>
                      you shall not interrupt the normal operation of the Platform or use any
                      methods to export or modify the source code of the Platform;
                    </li>
                    <li>
                      you shall not upload or send any kinds of computer viruses, worms, trojans, or
                      malicious codes;
                    </li>
                    <li>
                      you shall not install and/or execute the Platform on any device other than the
                      mobile device and web running the operating systems approved by MOVE; and
                    </li>
                    <li>
                      other than the licence to use the Platform granted hereof, no other licence or
                      right is hereby granted to you and the ownership of the Platform and all other
                      rights are hereby expressly reserved by Platform and its suppliers.
                    </li>
                  </ol>
                </p>
              </div>
              <h4>4. User Accounts</h4>
              <div className="space-y-5 text-justify">
                <p>
                  4.1 Users must be registered on the Sites to access or use some Services (a
                  registered User is also referred to as a “Member” below). Except with MOVE’s
                  approval, one User may only register one member account on the Sites. MOVE may
                  cancel or terminate a User’s member account if we have reasons to suspect that the
                  User has concurrently registered or controlled two or more member accounts.
                  Further, MOVE may reject User’s application for registration for any reason.
                </p>
                <p>
                  4.2 Once the Account registration is successfully completed with MOVE, you will be
                  provided with an Account, accessible with a password of your choice. The Services
                  or Platform may be restricted/limited based on your resident jurisdiction because
                  of age, in such cases you must abide by the age limits and not use the Services or
                  the Platform.
                </p>
                <p>
                  4.3 You agree that the details entered and maintained by you are accurate,
                  complete and valid. MOVE is not liable for false, incomplete, old or incorrect
                  registration information provided by you. Your failure to enter or maintain
                  accurate, complete, and valid information may result in your inability to access
                  and use the Services. You are responsible for all activity that occurs under your
                  Account. MOVE is entitled to verify the information that you have provided at all
                  times and refuse the use of the Services without providing reasons and prior
                  notice.
                </p>
                <p>
                  4.4 A set of Member ID and password is unique to a single account. Each Member
                  shall be solely responsible for maintaining the confidentiality and security of
                  your Member ID and password and for all activities that occur under your account.
                  No Member may share, assign, transfer, or permit the use of your Member account,
                  ID or password by another person outside of the Member’s own business entity.
                  Members agree to notify MOVE immediately if you become aware of any unauthorised
                  use of your password or your account or any other breach of security of your
                  account.
                </p>
                <p>
                  4.5 Member agrees that all activities that occur under your account (including
                  without limitation, posting any company or product information, clicking to accept
                  any Additional Agreements or rules, subscribing to or making any payment for any
                  services, sending emails using the email account or sending SMS) will be deemed to
                  have been authorised by the Member.
                </p>
                <p>
                  4.6 Member acknowledges that sharing of your account with other persons, or
                  allowing multiple users outside of your business entity to use your account
                  (collectively, "multiple use"), may cause irreparable harm to MOVE or other Users
                  of the Sites. Members shall indemnify MOVE, our affiliates, directors, employees,
                  agents and representatives against any loss or damages (including but not limited
                  to loss of profits) suffered as a result of the multiple use of your account.
                  Member also agrees that in case of the multiple use of your account or Member’s
                  failure to maintain the security of your account, MOVE shall not be liable for any
                  loss or damages arising from such a breach and shall have the right to suspend or
                  terminate Member’s account without liability to Member.
                </p>
                <p>
                  4.7 You are responsible for acquiring and updating compatible hardware or devices
                  necessary to access and use the Services and the Applications. MOVE does not
                  guarantee that the Services, or any portion thereof, will function on any
                  particular hardware or devices. MOVE reserves the right to terminate the use of
                  the Services should you be using the Service in an incompatible or unauthorised
                  device or that the security of your account has been compromised in any way or for
                  any reason we may find.
                </p>
              </div>
              <h4>5. Community Guidelines</h4>
              <div className="space-y-5 text-justify">
                <p>
                  5.1 Each Member represents, warrants and agrees that (a) you have full power and
                  authority to accept the Terms, to grant the licence and authorization and to
                  perform the obligations hereunder; (b) you use the Sites and Services for business
                  purposes only; and (c) the address you provide when registering is the principal
                  place of business of your business entity. For purposes of this provision, a
                  branch or liaison office will not be considered a separate entity and your
                  principal place of business will be deemed to be that of your head office.
                </p>
                <p>
                  5.2 Members will be required to provide information or material about your entity,
                  business or products/services as part of the registration process on the Sites or
                  your use of any Service or the member account. Each Member represents, warrants
                  and agrees that (a) such information and material whether submitted during the
                  registration process or thereafter throughout the continuation of the use of the
                  Sites or Service is true, accurate, current and complete, and (b) you will
                  maintain and promptly amend all information and material to keep it true,
                  accurate, current and complete.
                </p>
                <p>
                  5.3 Upon becoming a Member, you consent to the inclusion of the contact
                  information about you in our Client/Transporter Database and authorise MOVE and
                  our affiliates to share the contact information with other Users or otherwise use
                  your personal information in accordance with the Privacy Policy.
                </p>
                <p>
                  5.4 Each Member represents, warrants and agrees that (a) you shall be solely
                  responsible for obtaining all necessary third party licences and permissions
                  regarding any User Content that you submit, post or display; (b) any User Content
                  that you submit, post or display does not infringe or violate any of the
                  copyright, patent, trademark, trade name, trade secrets or any other personal or
                  proprietary rights of any third party (“Third Party Rights”); (c) you have the
                  right and authority to sell, trade, distribute or export or offer to sell, trade,
                  distribute or export the products or services described in the User Content and
                  such sale, trade, distribution or export or offer does not violate any Third Party
                  Rights and (d) you and your affiliates are not the subject of any trade
                  restrictions, sanctions or other legal restrictions enacted by any country,
                  international organisation or jurisdiction.
                </p>
                <p>
                  5.5 Each Member further represents, warrants and agrees that you shall/are/that:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      carry on your activities on the Sites in compliance with any applicable laws
                      and regulations;
                    </li>
                    <li>
                      conduct your business transactions with other users of the Sites in good
                      faith;
                    </li>
                    <li>
                      carry on your activities in accordance with the Terms and any applicable
                      Additional Agreements;
                    </li>
                    <li>
                      not use the Services or Sites to defraud any person or entity (including
                      without limitation sale of stolen items, use of stolen credit/debit cards);
                    </li>
                    <li>
                      not impersonate any person or entity, misrepresent yourself or your
                      affiliation with any person or entity; proof of identity or other
                      documentations needs to be submitted immediately if requested by MOVE;
                    </li>
                    <li>not engage in spamming or phishing;</li>
                    <li>
                      not engage in any other unlawful activities (including without limitation
                      those which would constitute a criminal offence, give rise to civil liability,
                      etc) or encourage or abet any unlawful activities; the Services cannot be used
                      for unlawful purposes, including but not limited to (i) violation of
                      Applicable Law; (ii) storing or sending any unlawful material; (iii) sharing
                      of sensitive personal information of others, without their consent (iv)
                      causing intentional harm, nuisance, inconvenience or annoyance; (v) impairing
                      or harming the proper operation of the Services; (vi) exhibiting the tenor of
                      impersonating another person; or (vii) copying or distributing the Services
                      without the permission of MOVE
                    </li>
                    <li>
                      you shall not use any "deep-link", "page-scrape", "robot", "spider" or other
                      automatic device, program, algorithm or methodology, or any similar or
                      equivalent manual process, to access, acquire, copy or monitor any portion of
                      the Platform or any content, or in any way reproduce or circumvent the
                      navigational structure or presentation of the Platform or any content, to
                      obtain or attempt to obtain any materials, documents or information through
                      any means not purposely made available through the Platform. MOVE reserves the
                      right to bar any such activities.
                    </li>
                    <li>
                      not engage in any activities that would otherwise create any liability for
                      MOVE or our affiliates;
                    </li>
                    <li>only access the Services using means explicitly authorised by MOVE;</li>
                    <li>
                      use the Platform and Services provided will solely be used by you, for your
                      personal use and will not be resold to any third party;
                    </li>
                    <li>
                      you will not engage with the Transporter/Client outside of the Platform
                      directly or indirectly;
                    </li>
                    <li>
                      you shall not attempt to interfere with, compromise the system integrity or
                      security or decipher any transmissions to or from the servers running the
                      Platform;
                    </li>
                    <li>
                      you shall not collect or harvest any personally identifiable information,
                      including account names, from the Platform;
                    </li>
                    <li>
                      you shall not engage in threatening, harassing, discriminatory (based on race,
                      gender, age, disability, or any other protected classification) or any other
                      behaviour that MOVE deems inappropriate when using the Services; and
                    </li>
                    <li>
                      you agree to grant MOVE the rights to share your information and/or permitted
                      information, with any third parties in accordance with MOVEs Privacy Policy.
                    </li>
                  </ol>
                </p>
                <p>
                  5.6 Member may not use the Services and member account to engage in activities
                  which are identical or similar to MOVEs business.
                </p>
                <p>
                  5.7 Member agrees to provide all necessary information, materials and approval,
                  and render all reasonable assistance and cooperation necessary for MOVEs provision
                  of the Services, evaluating whether Member has breached the Terms and/or handling
                  any complaint against the Member. If Member’s failure to do so results in delay
                  in, or suspension or termination of, the provision of any Service, MOVE shall not
                  be obliged to extend the relevant service period nor shall be liable for any loss
                  or damages arising from such delay, suspension or termination.
                </p>
                <p>
                  5.8 Member acknowledges and agrees that MOVE shall not be required to actively
                  monitor nor exercise any editorial control whatsoever over the content of any
                  message or material or information created, obtained or accessible through the
                  Services or Sites. MOVE does not endorse, verify or otherwise certify the contents
                  of any comments or other material or information made by any Member. Each Member
                  is solely responsible for the contents of their communications and may be held
                  legally liable or accountable for the content of their comments or other material
                  or information
                </p>
                <p>
                  5.9 Members acknowledge and agree that the Services may only be used by businesses
                  and their representatives for business use and not for individual consumers or for
                  personal use.
                </p>
                <p>
                  5.10 Member acknowledges and agrees that each Member is solely responsible for
                  observing applicable laws and regulations in its respective jurisdictions to
                  ensure that all use of the Site and Services are in compliance with the same.
                </p>
              </div>
              <h4>6. Rules for Users</h4>
              <div className="space-y-5 text-justify">
                <p>
                  6.1 Users warrant that they are either the owners or the authorised agents of the
                  owners of the goods and materials comprising any requested shipments and that the
                  Users are authorised to order that the shipments be made in accordance with the
                  Users’ instructions.
                </p>
                <p>
                  6.2 Users warrant that they have accepted these Terms not only for such Users but
                  (if applicable) also as agents for and on behalf of the owner of the goods and
                  materials comprising shipments.
                </p>
                <p>
                  6.3 Users understand that the Transporters will be directed by the User’s
                  instructions to transport the shipments to the User’s designated location. Users
                  agree that neither the Transporter nor MOVE holds title to or acquires any
                  ownership interest in any shipments that the Users request to be delivered through
                  the Services.
                </p>
                <p>
                  6.4 Users shall verify the information of the Transporter and vehicle and use the
                  User’s own discretion to decide whether or not to accept the services of the
                  Transporter before the shipment. Users shall be deemed to have accepted all
                  information (including but not limited to the information of the Transporter and
                  vehicle) relating to the shipment provided by the Transporter, whether or not such
                  information is identical with the User’s order information. After the shipment,
                  User shall not hold MOVE liable for any inconsistency between any information in
                  the shipment and the order information.
                </p>
                <p>
                  6.5 Users shall give to the Transporter sufficient, accurate and executable
                  instructions or orders. Any extra costs arising from the difference between the
                  Users’ provided information and the actual situation or facts involved shall be
                  borne by the User. Any amendment or change to a User’s instructions or orders (and
                  any pricing or cost changes triggered by such amendment or change) must be
                  approved and updated in the Application unless otherwise permitted by MOVE.
                </p>
                <p>
                  6.6 Users warrant that they have complied with all laws and regulations relating
                  to the nature, condition, packaging, handling, storage and carriage of the goods
                  and materials comprising shipments. Users shall not dispatch (and Transporters are
                  entitled to refuse transport of) any articles that are prohibited by law,
                  dangerous or hazardous materials, perishable substances, and radioactive material.
                  Users are liable for any loss or damages (including physical damages, lost
                  revenues, personal injuries, financial damages or losses, or any other loss or
                  damage) suffered by any third party as a result of a User’s breach of these Terms.
                  Users warrant that the goods to be delivered by the Transporter does not contain
                  or constitute:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>Fragile items without proper packaging that require special handling</li>
                    <li>Hazardous, explosive, flammable and unsafe items </li>
                    <li>Valuable items and documents </li>
                    <li>Credit or debit cards</li>
                    <li>Illegal substances, including including duty free alcohol or cigarettes</li>
                    <li>Live animals or otherwise and plants</li>
                    <li>Any unpacked / loose items that can be easily damaged in transit</li>
                    <li>Items exceeding size, dimensions or weight of selected vehicle type </li>
                    <li>Counterfeit goods</li>
                    <li>
                      Bullion, currency in any denomination, tax stamps / stickers, bearer forms or
                      negotiable instruments, precious metals / stones
                    </li>
                    <li>
                      Real or imitation weapons including firearms or parts thereof, explosives or
                      ammunition
                    </li>
                    <li>Human organs or remains (Ashes or bones)</li>
                    <li>Pornographic material</li>
                    <li>
                      Any item(s) of an aggregate value exceeding MYR 500 (Ringgit Malaysia Five
                      Hundred). You hereby agree that if you are desirous of insuring your goods,
                      you shall procure your own insurance coverage
                    </li>
                  </ol>
                </p>
                <p>
                  6.7 Transporters will not open and inspect shipments nor be responsible for the
                  transportation of special goods without prior agreement from the User. Except in
                  relation to Corporate Account User, MOVE and Transporters shall bear no
                  responsibility or any legal liability resulting from the transportation of
                  shipments.
                </p>
                <p>
                  6.8 Users shall ensure that shipments are adequately packed to protect against
                  damage in the course of transmission, and also that no part of any shipments can
                  be removed without the case, wrapper or container being torn or broken, a seal
                  being broken or two adhesive surfaces being forced apart.
                </p>
                <p>
                  6.9 Users shall ensure that shipments are properly packaged so as to protect
                  against damage to the shipments during the course of transportation, and in
                  particular, in the case of a shipment of a fragile nature or is susceptible to
                  damage by bending, that shipment shall be packaged in a case or container of
                  sufficient durability and strength and shall be encased in or surrounded by
                  sufficient and suitable protective material inside that case or container to
                  prevent the shipment from being bent, such that the shipment is guarded against
                  damage that may result from any force, pressure or blows to which transportation
                  items are ordinarily subject during the course of transportation and that such
                  fragile shipments shall bear specific words indicating its contains fragile items
                  displayed on the face of the case or container and above the address of the named
                  addressee.
                </p>
                <p>
                  6.10 MOVE shall not be responsible for providing a protective service for the
                  transportation of perishable commodities or commodities requiring protection from
                  heat or cold. Any additional protective service (if available) is provided solely
                  and directly by the Transporter. Such commodities will be accepted for
                  transportation solely at the User’s risk for any damages arising from the
                  transportation.
                </p>
                <p>
                  6.11 Users shall provide in respect of each shipment all necessary information. In
                  the event that the recipient is found to be absent from the address specified by
                  the User, no other person is present to take the shipment, and no other
                  instructions have been provided by the User, the Transporter will contact the User
                  (using the Platform) and attempt to return the shipment back to the User. In the
                  event the Transporter cannot reach the User, the Transporter may attempt to
                  redeliver the shipment to the recipient.
                </p>
                <p>
                  6.12 You agree that the unclaimed items which the recipient or User cannot be
                  contacted will be delivered to MOVE’s local office. If the items remain unclaimed
                  14 days after receipt of the items, MOVE can proceed with the unclaimed items at
                  its discretion. Any fees for additional handling and further shipment
                  transportation will be borne by the User. Should a re-transportation of items be
                  needed, a new transportation order will be placed and billed.
                </p>
                <p>
                  6.13 The Transporter is not required to help with loading, unloading, moving,
                  hauling or lifting the User’s shipment.
                </p>
                <p>
                  6.14 MOVE reserves the right to terminate the Account, Services and use of
                  Application in the event of non-compliance with any of the above requirements.
                  MOVE reserves the right to modify, terminate or suspend the Services to you at any
                  time, without prior notice, due to any changes in our internal policy or the
                  Applicable Laws or any breach of these Terms by you, or for any necessary reason
                  at MOVE’s sole discretion.
                </p>
              </div>
              <h4>7. Breaches by Users</h4>
              <div className="space-y-5 text-justify">
                <p>
                  7.1 MOVE reserves the right in our sole discretion to remove, modify or reject any
                  User Content that you submit to, post or display on the Sites which we reasonably
                  believe is unlawful, violates the Terms, could subject MOVE or our affiliates to
                  liability, or is otherwise found inappropriate in MOVE’s opinion.
                </p>
                <p>
                  7.2 If any Member breaches any Terms, or if MOVE has reasonable grounds to believe
                  that a Member is in breach of any Terms, MOVE shall have the right to take such
                  disciplinary actions as it deems appropriate, including without limitation: (i)
                  suspending or terminating the Member’s account and any and all accounts determined
                  to be related to such account by MOVE in its discretion; (ii) restricting,
                  downgrading, suspending or terminating the subscription of, access to, or current
                  or future use of any Service; (iii) imposing other restrictions on the Member’s
                  use of any features or functions of any Service as MOVE may consider appropriate
                  in its sole discretion; and (v) any other corrective actions, discipline or
                  penalties as MOVE may deem necessary or appropriate in its sole discretion.
                </p>
                <p>
                  7.3 Without limiting the generality of the provisions of the Terms, a Member would
                  be considered as being in breach of the Terms in any of the following
                  circumstances:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      upon complaint or claim from any Client, MOVE has reasonable grounds to
                      believe that such Transporter has willfully or materially failed to perform
                      your contract with such Client including without limitation where the
                      Transporter has failed to deliver any items ordered by such Client after
                      submission of transportation, or where the items Transporter has delivered
                      materially fail to meet the terms and descriptions outlined in your contract
                      with such Client,
                    </li>
                    <li>
                      MOVE has reasonable grounds to suspect that such Member has used a stolen
                      credit card or other false or misleading information in any transaction with a
                      counterparty,
                    </li>
                    <li>
                      MOVE has reasonable grounds to suspect that any information provided by the
                      Member is not current or complete or is untrue, inaccurate, or misleading, or
                    </li>
                    <li>
                      MOVE believes that the Member’s actions may cause financial loss or legal
                      liability to MOVE or our affiliates or any other Users.
                    </li>
                  </ol>
                </p>
                <p>
                  7.4 MOVE reserves the right to cooperate fully with governmental authorities,
                  private investigators and/or injured third parties in the investigation of any
                  suspected criminal or civil wrongdoing. Further, to the extent permitted by
                  applicable laws and policies, MOVE may disclose the Member's identity, contact
                  information and/or information regarding the Member's account(s), transactions or
                  activities carried out on or via the Site, if requested by a government or law
                  enforcement body, an injured third party, or as a result of a subpoena or other
                  legal action. MOVE shall not be liable for damages or results arising from such
                  disclosure, and the Member agrees not to bring any action or claim against MOVE
                  for such disclosure.
                </p>
                <p>
                  7.5 MOVE may, at any time and in our reasonable discretion, impose limitations on,
                  suspend or terminate the Member’s use of any Service or the Sites without being
                  liable to the Member if MOVE has received notice that the Member is in breach of
                  any agreement or undertaking with any affiliate of MOVE and such breach involves
                  or is reasonably suspected of involving dishonest or fraudulent activities. MOVE
                  shall not be required to investigate such breach or request confirmation from the
                  Member.
                </p>
                <p>
                  7.6 By accepting these Terms and using the Service, you agree that you shall
                  defend, indemnify and hold MOVE, its affiliates, its licensors, and each of their
                  officers, directors, other users, employees, attorneys and agents harmless from
                  and against any and all claims, costs, damages, losses, liabilities and expenses
                  (including attorneys' fees and costs) arising out of or in connection with:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      your violation or breach of any term of these Terms or any Applicable Law or
                      regulation, whether or not referenced herein;
                    </li>
                    <li>
                      your violation of any rights of any Member, including Transporter arranged via
                      the Platform; or
                    </li>
                    <li>your use or misuse of the Service.</li>
                  </ol>
                </p>
                <p>
                  7.7 Each Member further agrees that MOVE is not responsible, and shall have no
                  liability to you or anyone else for any User Content or other material transmitted
                  over the Sites, including fraudulent, untrue, misleading, inaccurate, defamatory,
                  offensive or illicit material and that the risk of damage from such material rests
                  entirely with each Member. MOVE reserves the right, at our own expense, to assume
                  the exclusive defence and control of any matter otherwise subject to
                  indemnification by the Member, in which event the Member shall cooperate with MOVE
                  in asserting any available defences.
                </p>
              </div>
              <h4>8. Limitation of Liability</h4>
              <div className="space-y-5 text-justify">
                <p>
                  8.1 To the maximum extent permitted by law, the services provided by MOVE on or
                  through the sites are provided "as is", "as available" and “with all faults”, and
                  move hereby expressly makes no representation, warranty, or guarantee regarding
                  the reliability, timeliness, quality, suitability, or availability of the services
                  or any services requested through the use of the services, or that the services
                  will be uninterrupted or error-free. MOVE does not control, manage or direct any
                  third party providers including Transporters. Third party providers are not actual
                  agents, apparent agents, ostensible agents, or employees of MOVE.
                </p>
                <p>
                  8.2 To the maximum extent permitted by law, MOVE makes no representations or
                  warranties about the validity, accuracy, correctness, reliability, quality,
                  stability, completeness or currentness of any information provided on or through
                  the sites; MOVE does not represent or warrant that the manufacture, importation,
                  export, distribution, offer, display, purchase, sale and/or use of products or
                  services offered or displayed on the sites does not violate any third party
                  rights; and MOVE makes no representations or warranties of any kind concerning any
                  product or service offered or displayed on the sites.
                </p>
                <p>
                  8.3 Any material downloaded or otherwise obtained through the Sites is done at
                  each User's sole discretion and risk and each User is solely responsible for any
                  damage to MOVE’s computer system or loss of data that may result from the download
                  of any such material. No advice or information, whether oral or written, obtained
                  by any User from MOVE or through or from the Sites shall create any warranty not
                  expressly stated herein. MOVE cannot and does not represent or warrant that the
                  services or servers are free of viruses or other harmful components.
                </p>
                <p>
                  8.4 The Sites may make available to User services or products provided by
                  independent third parties. No warranty or representation is made with regard to
                  such services or products. In no event shall MOVE and our affiliates be held
                  liable for any such services or products.
                </p>
                <p>
                  8.5 Each User hereby agrees to indemnify and save MOVE, our affiliates, directors,
                  officers and employees harmless, from any and all losses, claims, liabilities
                  (including legal costs on a full indemnity basis) which may arise from such User's
                  use of the Sites or Services (including but not limited to the display of such
                  User's information on the Sites) or from your breach of any of the terms and
                  conditions of the Terms. Each User hereby further agrees to indemnify and save
                  MOVE, our affiliates, directors, officers and employees harmless, from any and all
                  losses, damages, claims, liabilities (including legal costs on a full indemnity
                  basis) which may arise from User's breach of any representations and warranties
                  made by User to MOVE.
                </p>
                <p>
                  8.6 Each User hereby further agrees to indemnify and save MOVE, our affiliates,
                  directors, officers and employees harmless, from any and all losses, damages,
                  claims, liabilities (including legal costs on a full indemnity basis) which may
                  arise, directly or indirectly, as a result of any claims asserted by Third Party
                  Rights claimants or other third parties relating to products offered or displayed
                  on the Sites. Each User hereby further agrees that MOVEis not responsible and
                  shall have no liability to you, for any material posted by others, including
                  defamatory, offensive or illicit material and that the risk of damages from such
                  material rests entirely with each User. MOVE reserves the right, at our own
                  expense, to assume the exclusive defence and control of any matter otherwise
                  subject to indemnification by you, in which event you shall cooperate with MOVE in
                  asserting any available defences.
                </p>
                <p>
                  8.7 MOVE shall not be liable for any special, direct, indirect, punitive,
                  incidental or consequential damages or any damages whatsoever (including but not
                  limited to damages for loss of profits or savings, business interruption, loss of
                  information), whether in contract, negligence, tort, equity or otherwise or any
                  other damages resulting from any of the following:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>the use or the inability to use the Sites or Services;</li>
                    <li>
                      any defect in goods, samples, data, information or services purchased or
                      obtained from a User or any other third party through the Sites;
                    </li>
                    <li>
                      unauthorised access by third parties to data or private information of any
                      User;
                    </li>
                    <li>statements or conduct of any User of the Sites; or;</li>
                    <li>any matters relating to Services however arising, including negligence.</li>
                    <li>
                      damage/defect/change of item/property from its original state due to
                      substandard packaging;
                    </li>
                    <li>
                      item/property already damaged/defected/changed before the start of the
                      transportation;
                    </li>
                    <li>
                      quality of the Services as it is entirely dependent on the Transporter, who is
                      ultimately providing you the transportation and/or logistics services;
                    </li>
                    <li>any booking that is not accepted;</li>
                    <li>
                      any damages resulting from the use of or inability to use the Services,
                      including damages caused by wrong usage of the Services, error in call centre
                      number, network issues, malware, viruses or any incorrectness or
                      incompleteness;
                    </li>
                    <li>
                      appropriateness of mobile or email or any other communication medium. You
                      shall be responsible for immediately reporting the errors, if any, occurred in
                      the information sent to you regarding booking confirmation;
                    </li>
                    <li>
                      any direct, indirect, punitive, incidental, special or consequential damages
                      or for any damages whatsoever including profit and loss, whether based on
                      contract, tort, negligence, strict liability or otherwise, even if MOVE has
                      been advised of the possibility; and
                    </li>
                    <li>
                      any lost items during the Services, MOVE will try to locate the items on a
                      "best-effort" basis but is not responsible for any loss or damages of such
                      items.
                    </li>
                  </ol>
                </p>
                <p>
                  8.8 If any provision of these Terms is held to be illegal, invalid or
                  unenforceable, in whole or in part, under any law, such provision or part thereof
                  shall to that extent be deemed not to form part of these Terms but the legality,
                  validity and enforceability of the other provisions in these Terms shall not be
                  affected. In that event, the parties shall replace the illegal, invalid or
                  unenforceable provision or part thereof with a provision or part thereof that is
                  legal, valid and enforceable and that has, to the greatest extent possible, a
                  similar effect as the illegal, invalid or unenforceable provision or part thereof,
                  given the contents and purpose of these Terms.
                </p>
                <p>
                  8.9 The limitations and exclusions of liability to you under the Terms shall apply
                  to the maximum extent permitted by law and shall apply whether or not MOVE has
                  been advised of or should have been aware of the possibility of any such losses
                  arising.
                </p>
              </div>
              <h4>9. Force Majeure</h4>
              <div className="space-y-5 text-justify">
                <p>
                  Under no circumstances shall MOVE be held liable for any delay or failure or
                  disruption of the content or services delivered through the Sites resulting
                  directly or indirectly from acts of nature, forces or causes beyond our reasonable
                  control, including without limitation, Internet failures, computer,
                  telecommunications or any other equipment failures, electrical power failures,
                  strikes, labour disputes, riots, insurrections, civil disturbances, shortages of
                  labour or materials, fires, flood, storms, explosions, acts of God, war,
                  governmental actions, orders of domestic or foreign courts or tribunals or
                  non-performance of third parties.
                </p>
              </div>
              <h4>10. Payment on the Services</h4>
              <div className="space-y-5 text-justify">
                <p>
                  10.1 Use of the Platform is free of cost, but MOVE reserves the right to introduce
                  a fee for the use of the Platform. (If we introduce this fee you will be notified
                  and you can decide to continue or terminate your Account). <br />
                  While using the Services you understand and agree that:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      MOVE shall charge you any applicable taxes and any other fees that may be due
                      for a particular use of the Service (“Charges”) for the transportation
                      services and other services provided to you by the Delivery Partner. Payment
                      of the Charges in such manner shall be considered the same as Charges made
                      directly by you to the Transporter and such Charges may fluctuate from time to
                      time subject to supply and demand and any other factors;
                    </li>
                    <li>
                      the Charges is due upon the order is placed and will be deducted from your
                      preferred payment method designated in your Account;
                    </li>
                    <li>
                      the Charges paid are non-refundable, unless otherwise determined by MOVE on a
                      case-by-case basis;
                    </li>
                    <li>
                      Charges quoted are in Malaysian Ringgit with applicable taxes where required
                      by law;
                    </li>
                    <li>
                      any priority fee or add-on fee is voluntary, however once you select to pay
                      those fees, they will be added into the Charges and you are obliged to pay
                      them;
                    </li>
                    <li>
                      MOVE reserves all right to adjust the charges based on actual circumstances;
                    </li>
                    <li>
                      any application/request for service is subjected to availability of resources.
                      In the event any application submitted is not processed, MOVE shall inform the
                      User by email, text message, calls, or push notifications to the mobile device
                      or cellphone number you provide to MOVE;
                    </li>
                    <li>
                      MOVE reserves its full discretion to determine whether to refund to the User
                      the equivalent sum of amount paid in the event MOVE for any reason is unable
                      to process the application/request;
                    </li>
                    <li>
                      You may elect to cancel your request for services from the Transporter at any
                      time prior to the arrival of Transporter, in which case you may be charged a
                      cancellation fee without prior notice;
                    </li>
                    <li>receipt is issued to the User when the payment is successful. </li>
                    <li>
                      MOVE retains the right to suspend the processing of any transaction where it
                      reasonably believes that the transaction may be fraudulent, illegal or
                      involves any criminal activity or where you and/or the sender/recipient have
                      breached any of the Terms in this Agreement. In such an event, you shall not
                      hold MOVE liable for any withholding of, delay in, suspension, forfeiture or
                      cancellation of, any payment(s) to you.
                    </li>
                  </ol>
                </p>
                <p>
                  10.2 You can choose to pay for the Charges by the following methods:
                  <ol className="list-[upper-alpha] list-inside pl-5 space-y-5 pt-3">
                    <li>
                      Electronic Payment Gateways:
                      <ol className="list-[lower-alpha] list-inside pl-5 pt-2">
                        <li>
                          You may settle the Charges through third-party Electronic Payment
                          Gateways. The process of the payment is subject to the confirmation from
                          the third party payment processor ("Payment Processor"). MOVE is not
                          responsible for any errors on the Payment Processor’s end. MOVE shall not
                          be responsible for any unauthorised use of your Electronic Payment
                          Gateways during or after availing the Services.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Credit Card:
                      <ol className="list-[lower-alpha] list-inside pl-5 pt-2">
                        <li>
                          MOVE offers you the facility to make payments through a credit card
                          enabled by Payment Gateways (“PGs”) or Payment Processors provided by any
                          of MOVE’s affiliates or partners or unrelated third parties. You agree and
                          undertake to share relevant payment details including credit/debit card
                          details (“Card Details”) with the PGs and the Payment Processors for the
                          successful completion of payment towards total transaction amount to MOVE
                          and authorise the PGs and the Payment Processors to complete such
                          transactions. In this respect, it is clarified that all PGs and the
                          Payment Processors whose services are utilised for the purposes of the
                          Services shall be PCI-DSS (“Payment Card Industry – Data Security
                          Standard”) compliant. Your authorization will remain in effect as long as
                          you maintain an Account in the Platform. In the event you delete your Card
                          Details with the PG or the Payment Processors or if you delete your
                          Account, the PGs or the Payment Processors will not process any further
                          transactions initiated by you. Your authorization under this clause is
                          subject to any other terms and conditions of the PGs and the Payment
                          Processors. MOVE shall not be responsible for any issue from payments via
                          credit/debit cards.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </p>
                <p>
                  10.3 Any payment related issue, except when such issue is due to an error or fault
                  of MOVE, shall be resolved between you and the PGs or Payment Processors. The
                  processing of the credit or payment, as applicable, are subjected to all
                  applicable terms and conditions, privacy policies and other terms of applicable
                  PGs or Payment Processors and your credit/debit card scheme in addition to these
                  Terms. MOVE cannot be held responsible for any errors or faults resulting from the
                  Payment Processors.
                </p>
              </div>
              <h4>11. Intellectual Property Rights</h4>
              <div className="space-y-5 text-justify">
                <p>
                  11.1 MOVE alone (and its licensors, where applicable) shall own all right, title
                  and interest, including all related intellectual property rights, in and to the
                  Platform and the Services. These Terms do not constitute a sale and do not convey
                  to you any rights of ownership in or related to the Platform and the Services, or
                  any intellectual property rights owned by MOVE.
                </p>
                <p>
                  11.2 Company names, logos, and the product names associated with the Platform and
                  the Services are trademarks and/or intellectual property of MOVE or third parties,
                  and no right or licence is granted to use them. You agree that you will not
                  remove, alter or obscure any copyright, trademark, service mark or other
                  proprietary rights notices incorporated in or accompanying the Platform and the
                  Services.
                </p>
                <p>
                  11.3 By providing content, information or materials (“User Content”) to MOVE you
                  grant MOVE a worldwide, perpetual, irrevocable, transferrable, royalty-free
                  licence, with the right to sublicense, to use, copy, modify, create derivative
                  works of, distribute, publicly display, publicly perform, and otherwise exploit in
                  any manner such User Content in all formats and distribution channels now known or
                  hereafter devised, without further notice to or consent from you, and without the
                  requirement of payment to you or any other person or entity.
                </p>
                <p>
                  11.4 MOVE respects your rights to your ideas, please do not submit any
                  confidential ideas, information, or suggestions in any form to MOVE or any of its
                  affiliates. For any ideas, information, or suggestions you do submit, regardless
                  of what your communication regarding your submissions says, you understand that
                  your submissions are voluntary and the following terms shall apply to your
                  submissions: (i) your submissions and their contents will automatically become the
                  property of MOVE, without any compensation to you; (ii) MOVE has no obligation to
                  review your submissions; (iii) MOVE may implement and distribute any portion of
                  your submissions and their contents for any purpose in any way, without any
                  compensation to you; and (iv) MOVE has no obligation to keep your submissions
                  confidential.
                </p>
                <p>
                  11.5 These Terms do not constitute a sale and do not convey to you any rights of
                  ownership in or related to the website, the Application or the Service, or any
                  intellectual property rights owned by MOVE.
                </p>
              </div>
            </div>
          </div>
        </div>
        <SignUpButtonGroup />
      </div>
    </StaticPageLayout>
  );
};

export default TermsOfServicePage;
